module.exports = __webpack_public_path__ + "static/img/12.cbc04df.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/20/eng/12.png
// module id = HyQb
// module chunks = 0